import { render, staticRenderFns } from "./DynamicModelCreator.vue?vue&type=template&id=4934587e&scoped=true&"
import script from "./DynamicModelCreator.vue?vue&type=script&lang=js&"
export * from "./DynamicModelCreator.vue?vue&type=script&lang=js&"
import style0 from "./DynamicModelCreator.vue?vue&type=style&index=0&id=4934587e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934587e",
  null
  
)

export default component.exports